import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function placeCameraForceState() {
    return (
        <div data-cy="history-forceState">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.forceState" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faLock} style={{ color: 'orange' }} size="lg" />
            </Whisper>
        </div>
    );
}
